import { handleRest } from '../../h2Api'
import {
  PROFILE_NOTES_ADDED,
  PROFILE_NOTES_LOADED
} from '../../actions/admin/adminLocalOpportunityActions'

const initialRequestState = handleRest()
const reducers = (state = initialRequestState, action) => {
  switch (action.type) {
    case PROFILE_NOTES_LOADED:
      return {
        ...state,
        ...handleRest(action)
      }
    case PROFILE_NOTES_ADDED:
      console.log(state)

      return {
        ...state,
        result: [action.result, ...state.result]
      }
    default:
      return state
  }
}

export default reducers
